import {
  AboutSectionWrapper,
  AboutBanner,
  H3,
  P,
  SocialMediaWrapper,
  SocialMedia,
  Ul,
  Li,
  SocialMediaLink,
  H3SocialMedia,
} from "./About.style";

// icons
import { FaGithub, FaLinkedin, FaMailBulk } from "react-icons/fa";

const About = () => {
  return (
    <AboutSectionWrapper id="about">
      <AboutBanner>
        <H3>Sobre mim</H3>
        <P>
          Como desenvolvedor, direciono meus esforços para o aperfeiçoamento das
          minhas habilidades nas tecnologias voltadas para o Desenvolvimento
          Front-End. Abranjo conhecimentos em Javascript, ReactJS, React Hooks,
          ReactRouter, Context API, Consumo de APIs e Styled-Components.
        </P>
      </AboutBanner>
      <SocialMediaWrapper>
        <H3SocialMedia>Redes Sociais</H3SocialMedia>
        <SocialMedia>
          <Ul>
            <Li>
              <SocialMediaLink
                href="https://github.com/jpcchaves"
                target="_blank"
              >
                <FaGithub />
              </SocialMediaLink>
            </Li>
            <Li>
              <SocialMediaLink
                href="https://www.linkedin.com/in/joaopaulo-chaves/"
                target="_blank"
              >
                <FaLinkedin />
              </SocialMediaLink>
            </Li>
            <Li>
              <SocialMediaLink
                href="mailto: jpcchaves@outlook.com"
                target="_blank"
              >
                <FaMailBulk />
              </SocialMediaLink>
            </Li>
          </Ul>
        </SocialMedia>
        <P>
          Estas são as minhas redes para contato. Caso tenha interesse em
          visualizar meu repositório no GitHub, conectar-se comigo no Linkedin
          ou enviar um E-mail, basta clicar no ícone correspondente acima!
        </P>
      </SocialMediaWrapper>
    </AboutSectionWrapper>
  );
};

export default About;
